import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ReactPaginate from 'react-paginate'
import news from '../../assets/img/news/news1.jpg'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import logo from '../../assets/img/logo_small.png'
import sten from '../../assets/img/news/genetic_service.png'
import news2 from '../../assets/img/news/news.png'
import open from '../../assets/img/news/open_new.jpg'
import uudel_es from '../../assets/img/news/uudel_es.png'
import blood from '../../assets/img/news/blood.png'
import blood4 from '../../assets/img/news/blood_2.jpg'
import sc2 from '../../assets/img/news/sc2_1.png'
import rightArrow from '../../assets/img/CaretRight.png'
import { useNavigate } from 'react-router-dom'
import Header from '../Header'

const categories = ['Бүгд', 'Мэдээ', 'Блог', 'Судалгаа', 'Зарлал']
const contents = [
  {
    id: 1,
    date: '2025/01/10',
    title:
      'Монгол Улсад анх удаа үүдэл эсийн банк болон эсийн эмчилгээний бүтээгдэхүүн үйлдвэрлэх хамгийн орчин үеийн дэвшилтэт технологийг нэвтрүүлсэн Селл Клиник эмнэлэг албан ёсоор үйл ажиллагаагаа эхлүүллээ.',
    description:
      'Манай эмнэлэг нь олон улсын GMP лабораторийн стандартын дагуу эс боловсруулах, хадгалах, эсийн эмчилгээний үйлчилгээг санал болгож байна.',
    category: 'Мэдээ',
    img: open
  },
  {
    id: 2,
    date: '2025/02/05',
    title: 'Эсийн банк гэж юу вэ? ...яагаад чухал вэ?',
    description:
      'Эсийн банк гэдэг нь ирээдүйд эмчилгээ, судалгаанд ашиглах зорилгоор эсийг цуглуулан, боловсруулж хадгалдаг эрүүл мэндийн байгууллагыг хэлнэ. Энэ нь эрүүл мэндийн салбар болон биотехнологийн салбарт найдвартай, тогтвортой эсийн нөөцийг бүрдүүлэх чухал ач холбогдолтой.',
    category: 'Блог',
    img: news2
  },
  {
    id: 3,
    date: '2025/02/11',
    title: 'Үүдэл эсийн ангилал',
    description:
      'Үүдэл эсүүд нь өөрийгөө олшруулах чадвартай, ялгаран хөгжөөгүй эсүүд бөгөөд олон төрлийн эс болж ялгаран хөгжих чадвартай.',
    category: 'Блог',
    img: sten
  },
  {
    id: 4,
    date: '2025/02/16',
    title: 'Үүдэл эсийн судалгааны түүх',
    description:
      'Үүдэл эсийн судалгаа нь анагаах ухаан, био анагаах ухаан ялангуяа эсийн биологи, нөхөн төлжүүлэх анагаах ухааны хамгийн чухал ололтуудын нэг билээ.',
    category: 'Блог',
    img: uudel_es
  },
  {
    id: 5,
    date: '2025/04/17',
    title: 'Хүйн цус яагаад гайхамшигтай вэ?',
    description:
      'Хүүхдээ өлгийдөн авах тэр нандин агшинд хүүхдийн тань ирээдүйн эрүүл мэндийн баталгаа болох нэгэн үнэт баялаг дагаж ирдгийг та мэдэх үү?',
    category: 'Блог',
    img: blood
  },
  {
    id: 6,
    date: '2025/04/17',
    title: 'Хүний биеийн нууцлаг эрдэнэс: Эсийн банкны ач холбогдол',
    description:
      'Амьд эсийг хөлдөөж хадгалах гайхамшиг. Та хэзээ нэгэн цагт "амьд зүйлийг хөлдөөж хадгалж болдог" гэж сонсож байсан уу? Энэ нь зөвхөн уран зөгнөлт киноны сэдэв биш, бодит амьдрал дээр биологичид, эмч, биоанагаахын судлаач нар хийж чаддаг болсон шинжлэх ухааны шинэ технологи юм.',
    category: 'Блог',
    img: blood4
  },
  {
    id: 7,
    date: '2025/04/25',
    title:
      'Селл Клиник – SciCon 2025 Шинжлэх ухаанд шимтэгсдийн баярт амжилттай оролцлоо',
    description:
      'Манай эмнэлэг  нь Монголын шинжлэх ухаанд шимтэгчдийн хамгийн том баяр болох SciCon – Science Conference 2025: Quantum Era арга хэмжээг “Gej Yu Ve?”-ын залуустай хамтран зохион байгуулж оролцож, шинжлэх ухааны боловсролыг олон нийтэд таниулах үйлсэд хувь нэмэр орууллаа.',
    category: 'Блог',
    img: sc2
  }
]

export default function News () {
  const navigate = useNavigate()
  const [selectedCategory, setSelectedCategory] = useState('Бүгд')
  const itemsPerPage = 6
  const [currentPage, setCurrentPage] = useState(0)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  // Function to handle category change
  const changeCategory = category => {
    setSelectedCategory(category)
    setCurrentPage(0)
  }

  const handlePageClick = event => {
    setCurrentPage(event.selected)
  }

  const offset = currentPage * itemsPerPage
  const filteredContents = (
    selectedCategory === 'Бүгд'
      ? [...contents]
      : contents.filter(item => item.category === selectedCategory)
  ).sort((a, b) => b.id - a.id)

  const paginatedItems = filteredContents.slice(offset, offset + itemsPerPage)

  const callNewsDetail = id => {
    console.log(id)
    navigate(`/news/${id}`)
    window.scrollTo(0, 0)
  }

  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>

      <div className='self-stretch bg-white '>
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : '#235998'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-white'}
          />
        </div>
        {/* <Header color='blue' gradientColor='white' /> */}
        <div className='  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto p-10 mobile:p-0'>
          <main className='flex flex-col mobile:p-1 '>
            <div
              className='flex flex-col justify-end h-[50vh] faq-screen bg-cover bg-center bg-no-repeat w-full p-10 cursor-pointer mobile:p-0 rounded-2xl mobile:rounded-none'
              onClick={() => callNewsDetail(1)}
              style={{ backgroundImage: `url(${news})` }}
            >
              <div className='flex flex-row justify-between'>
                <div className='mobile:hidden'>
                  <button className='border border-white w-24 rounded-xl text-white'>
                    Мэдээ
                  </button>
                  <p className='text-2xl font-bold w-1/2 text-white'>
                    CELLCLINIC ЭСИЙН БАНК & ЭСИЙН ЭМЧИЛГЭЭНИЙ ЭМНЭЛЭГ АЛБАН
                    ЁСООР ҮҮД ХААЛГАА НЭЭЛЭЭ
                  </p>
                </div>
                <div className='flex flex-row items-end justify-center mobile:hidden'>
                  <div className='h-10 w-10'>
                    <img src={logo} alt='olo' />
                  </div>
                  <div className='text-white ml-2 text-sm'>
                    <p>CellClinic</p>
                    <p>2025/01/10</p>
                  </div>
                </div>
              </div>
            </div>
          </main>
          {/* body section */}
          <div className='h-full '>
            <div className='flex flex-row mobile:flex-col'>
              {/* category */}
              <div className='flex flex-col w-[280px] py-10 mobile:flex-row mobile:px-5 mobile:py-2'>
                <span className='text-sm font-bold text-[#215998] mb-2 mobile:hidden'>
                  Ангилал
                </span>
                {categories.map((category, index) => (
                  <button
                    key={index}
                    onClick={() => changeCategory(category)}
                    className={`p-2 text-sm h-10 text-left border-t-0 border-r-0 border-b-0
                              font-${
                                selectedCategory === category
                                  ? 'bold'
                                  : 'normal'
                              } border-b border-[#215998] ${
                      selectedCategory === category ? 'border-l' : ''
                    } ${
                      selectedCategory === category
                        ? 'text-[#215998]'
                        : 'text-[#626578]'
                    } cursor-pointer`}
                  >
                    {category}
                  </button>
                ))}
              </div>
              <div className='w-full ml-5 mobile:ml-0 mobile:px-5'>
                <div className='grid grid-cols-2 gap-5 mt-10 mobile:mt-0 mobile:grid-cols-1 mobile:gap-0 cursor-pointer'>
                  {paginatedItems.map((item, index) => (
                    <div
                      key={index}
                      className='rounded-xl border border-[#EDEFFA]'
                      onClick={() => callNewsDetail(item.id)}
                    >
                      <div className='rounded-xl h-[400px] w-full overflow-hidden p-5 mobile:h-[200px]'>
                        <img
                          className='rounded-xl h-full w-full mobile:h-[200px] object-cover'
                          src={item.img}
                          alt='s'
                        />
                      </div>

                      <p className='p-5 mb-[-20px]'>{item.date}</p>

                      <div className='flex flex-row justify-between '>
                        <div className='p-5'>
                          <h3 className='font-bold mb-4'>{item.title}</h3>
                          <p>{item.description}</p>
                          <button className='border border-white w-24 rounded-xl text-white'>
                            {item.category}
                          </button>
                        </div>
                        <div
                          className='h-[120px] w-[60px] flex justify-center relative flex-shrink-0 overflow-hidden mobile:hidden cursor-pointer '
                          style={{
                            border: '1px solid #CED2E8',
                            borderRight: 'none',
                            borderRadius: '100px 0 0 100px'
                          }}
                          onClick={() => callNewsDetail(item.id)}
                        >
                          <img
                            src={rightArrow}
                            alt=''
                            style={{
                              position: 'absolute',
                              top: '35%',
                              left: 20,
                              zIndex: 2,
                              height: '30%',
                              objectFit: 'cover'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className='relative mt-4'>
                  <ReactPaginate
                    previousLabel={'← Өмнөх'}
                    nextLabel={'Дараагийнх →'}
                    pageCount={Math.ceil(contents.length / itemsPerPage)}
                    onPageChange={handlePageClick}
                    containerClassName='flex justify-center items-center gap-2'
                    activeClassName='bg-blue-500 text-white font-bold border border-blue-500'
                    pageClassName='px-3 py-1 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-200 text-[#182230] bg-white'
                    previousClassName='absolute left-0 px-3 py-1 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-200'
                    nextClassName='absolute right-0 px-3 py-1 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-200'
                    breakClassName='px-3 py-1 border border-gray-300 rounded-md cursor-pointer'
                    disabledClassName='opacity-50 cursor-not-allowed'
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='mt-10 mobile:px-5 mobile:mt-5'>
            <ConnectUs bgImage='blue' />
            <FooterSection />
          </div>
        </div>
      </div>
    </>
  )
}
